import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { bootMobile } from "@/lib/mobile";

// Suppress benign ResizeObserver loop errors that trigger the CRA dev overlay
// (thrown by recharts + shadcn tabs on responsive charts).
const RO_MSGS = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver loop completed with undelivered notifications.",
];
window.addEventListener("error", (e) => {
  if (e.message && RO_MSGS.some((m) => e.message.includes(m))) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
}, true);
window.addEventListener("unhandledrejection", (e) => {
  const m = e.reason?.message || "";
  if (RO_MSGS.some((x) => m.includes(x))) e.preventDefault();
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Native shell boot — hides splash, sets dark status bar, wires Android back button.
// Safe no-op on plain web.
bootMobile();
